import { endOfMonth, setDate } from 'date-fns';

import WeekNumber from './WeekNumber';
import Flex from '../Flex';

import { getBeginOfWeek, getDayOfWeek, getWeekNumber } from '../shared/dates';

import type { OnClickWeekNumberFunc } from '../shared/types';

type WeekNumbersProps = {
	activeStartDate: Date;
	onClickWeekNumber?: OnClickWeekNumberFunc;
	showFixedNumberOfWeeks?: boolean;
	baseClassName?: string;
};

export default function WeekNumbers(props: WeekNumbersProps) {
	const { activeStartDate, onClickWeekNumber, showFixedNumberOfWeeks, baseClassName } = props;

	const numberOfWeeks = (() => {
		if (showFixedNumberOfWeeks) {
			return 6;
		}

		const numberOfDays = endOfMonth(activeStartDate).getDate();
		const startWeekday = getDayOfWeek(activeStartDate);

		const days = numberOfDays - (7 - startWeekday);
		return 1 + Math.ceil(days / 7);
	})();

	const dates = (() => {
		const result: Date[] = [];
		for (let index = 0; index < numberOfWeeks; index += 1) {
			result.push(getBeginOfWeek(setDate(activeStartDate, activeStartDate.getDate() + index * 7)));
		}
		return result;
	})();

	const weekNumbers = dates.map(date => getWeekNumber(date));

	return (
		<Flex
			className={`${baseClassName}__month-view__weekNumbers`}
			count={numberOfWeeks}
			direction="column"
			style={{ flexBasis: 'calc(100% * (1 / 8)', flexShrink: 0 }}
		>
			{weekNumbers.map((weekNumber, weekIndex) => {
				const date = dates[weekIndex];

				if (!date) {
					throw new Error('date is not defined');
				}

				return (
					<WeekNumber
						key={weekNumber}
						date={date}
						onClickWeekNumber={onClickWeekNumber}
						weekNumber={weekNumber}
						baseClassName={baseClassName}
					/>
				);
			})}
		</Flex>
	);
}
